module.exports = __webpack_public_path__ + "img/foot-logo.7fa29be7.png";